import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes"
import { 
  apiError, 
  loginSuccess, 
  logoutUserSuccess,
  otpGenerateSuccess,
  otpVerifySuccess,
  otpActionError,
} from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper"
import { openWelcome } from "store/agenda/action"


const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        async (url = process.env.REACT_APP_ADMIN + "/login", data = user) => {
          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
          })
          return res.json()
        }
      )

      console.log("login response:", response)

      // ── Success cases ──────────────────────────────────────
      if (response.mssg === "OTP sent successfully to your email") {
        yield put(otpGenerateSuccess(response.mssg))
      }
      else if (response.mssg === "User Verified") {
        localStorage.setItem("authUser", JSON.stringify(response.data))
        yield put(otpVerifySuccess(response.mssg, response.data))
        yield put(loginSuccess(response.data))           // keep your existing success
        yield put(openWelcome())
        history.push("/dashboard")
      }

      // ── Error cases ────────────────────────────────────────
      else if (response.mssg) {
        // All other error messages from backend
        yield put(otpActionError(response.mssg))
      }
      else {
        // Fallback unknown error
        yield put(otpActionError("Something went wrong! Please try again."))
      }
    }
    // ... rest of your if conditions (jwt/fake) remain same
  } catch (error) {
    yield put(otpActionError(error.message || "Network error occurred"))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    localStorage.removeItem("notificationToken")
    localStorage.removeItem("activityArr")
    // openWelcome()
    // if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
    //   const response = yield call(fireBaseBackend.logout)
    //   yield put(logoutUserSuccess(response))
    // }
    CometChatWidget.logout().then(response => {
      // User successfully logged out.
    // Perform any clean up if required.
    console.log("chat logout success!");
  });
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type,
      )
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    } else {
      const response = yield call(postSocialLogin, data)
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    }
    history.push("/dashboard")
    // window.location.href="/page/lobby"
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
